import {Injectable} from '@angular/core';
import {Announcement} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class AnnouncementsAdminService extends TableOptionsService<Announcement> {
    constructor() {
        super();
    }

    public override matches(element: Announcement, term: string) {
        return element.message?.toLowerCase().includes(term.toLowerCase());
    }
}
